import SquareTable from './SquareTable'

export default SquareTable
